/**
 * @file PRO Admin Custom Prints related queries.
 */

import gql from 'graphql-tag';

import { PurchasedCustomPrintFields } from '../fragments/pro-custom-prints';

export const PurchasedCustomPrint = gql`
  query purchasedCustomPrint($id: RecordID!) {
    purchasedCustomPrint(id: $id) {
      id
      ...PurchasedCustomPrintFields
    }
  }
  ${PurchasedCustomPrintFields}
`;
